var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { onError } from "@ane/core/lib/decorators/OnError";
import { RestServiceBase, RestResult } from "@ane/core/lib/services/RestServiceBase";
import { continuationErrorMessage } from "../constants/FeatureDataConstants.js";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { expAdapterService } from "../services/middlewares/ExpAdapterMiddleware.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let FeatureResources = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/api/");
    __publicField(this, "version", "1.0");
  }
  createRootFeature(postData) {
    return __async(this, null, function* () {
      const address = `features`;
      const response = yield this._post(postData, address);
      return response.getSuccessData();
    });
  }
  updateRootFeature(postData, id) {
    return __async(this, null, function* () {
      const address = `features/${id}`;
      const response = yield this._patch(postData, address);
      response.ensureSuccess();
    });
  }
  initializeRootFeature(id) {
    return __async(this, null, function* () {
      const address = `experiments/${id}/initialize`;
      const response = yield this._post("", address);
      return response.getSuccessData();
    });
  }
  initializeRootFeatureRestResult(featureId) {
    return __async(this, null, function* () {
      const address = `experiments/${featureId}/initialize`;
      const response = yield this._post("", address);
      return response;
    });
  }
  loadRootFeature(id) {
    return __async(this, null, function* () {
      const address = `features/${id}`;
      const result = yield this._get(address);
      const json = result.getSuccessData();
      return json;
    });
  }
  loadRootFeatureV2(id) {
    return __async(this, null, function* () {
      const address = `features/${id}`;
      const result = yield this._get(address);
      return result;
    });
  }
  tryGetFlightRestResult(name, managementGroup, workspaceId = null, populateRelatedExperiments = true) {
    return __async(this, null, function* () {
      const tenantId = managementGroup.split("/")[1];
      const workspaceParam = !!workspaceId ? `&workspaceId=${workspaceId}` : "";
      const populateRelatedExperimentsParam = `populateRelatedExperiments=${populateRelatedExperiments ? "true" : "false"}`;
      const address = `2.0/tenants/${tenantId}/flights/${name}?${populateRelatedExperimentsParam}&managementGroup=${managementGroup}${workspaceParam}`;
      const result = yield this._get(address);
      if (result.statusCode === 404) {
        return RestResult.fromResult(null, false);
      }
      if (result.isSuccessful() && result.getSuccessData() === null) {
        return RestResult.fromResult(null, false);
      }
      return result;
    });
  }
  tryDeleteFlight(name, managementGroup) {
    return __async(this, null, function* () {
      let tenantId = managementGroup.split("/")[1];
      const address = `2.0/tenants/${tenantId}/flights/${name}?allowInvalidFrState=false&managementGroup=${managementGroup}`;
      const result = yield this._delete(address);
      return result;
    });
  }
  getFlight(name, managementGroup, workspaceId = null, populateRelatedExperiments = true) {
    return __async(this, null, function* () {
      const tenantId = managementGroup.split("/")[1];
      const workspaceParam = !!workspaceId ? `&workspaceId=${workspaceId}` : "";
      const populateRelatedExperimentsParam = `populateRelatedExperiments=${populateRelatedExperiments ? "true" : "false"}`;
      const address = `2.0/tenants/${tenantId}/flights/${name}?${populateRelatedExperimentsParam}&managementGroup=${managementGroup}${workspaceParam}`;
      const result = yield this._get(address);
      return result;
    });
  }
  createProgression(featureId, postData) {
    return __async(this, null, function* () {
      const address = `features/${featureId}/progressions`;
      const response = yield this._post(postData, address);
      return response.getSuccessData();
    });
  }
  createProgressionRestResult(featureId, postData) {
    return __async(this, null, function* () {
      const address = `features/${featureId}/progressions`;
      return yield this._post(postData, address);
    });
  }
  createProgressionStage(featureId, progressionId, position, progressionStageConfig) {
    return __async(this, null, function* () {
      const address = `${this.version}/features/${featureId}/progressions/${progressionId}/stages?afterIndex=${position - 1}`;
      const result = yield this._post(progressionStageConfig, address);
      return result.getSuccessData();
    });
  }
  cloneProgression(featureId, progressionId, postData) {
    return __async(this, null, function* () {
      const address = `${this.version}/features/${featureId}/progressions/${progressionId}/clone`;
      const response = yield this._post(postData, address);
      return response.getSuccessData();
    });
  }
  hideFeature(featureId) {
    return __async(this, null, function* () {
      const address = `features/${featureId}`;
      const response = yield this._delete(address);
      response.ensureSuccess();
      return response;
    });
  }
  archiveProgression(featureId, progressionId, hideProgression = false) {
    return __async(this, null, function* () {
      const address = `features/${featureId}/progressions/${progressionId}?hideProgression=${hideProgression}`;
      const response = yield this._delete(address);
      return response.getSuccessData();
    });
  }
  setTargetOrder(featureId, postData) {
    return __async(this, null, function* () {
      const address = `rollouts/${featureId}/targets/order`;
      const response = yield this._patch(postData, address);
      return response.getSuccessData();
    });
  }
  updateProgressionsStage(featureId, progressionId, stageId, postData) {
    return __async(this, null, function* () {
      const address = `1.0/features/${featureId}/progressions/${progressionId}/stages/${stageId}`;
      const result = yield this._post(postData, address);
      return result.getSuccessData();
    });
  }
  deleteProgressionsStage(featureId, progressionId, stageId) {
    return __async(this, null, function* () {
      const address = `1.0/features/${featureId}/progressions/${progressionId}/stages/${stageId}`;
      const result = yield this._delete(address);
      return result.getSuccessData();
    });
  }
  cloneProgressionStage(featureId, progressionId, stageId, postData) {
    return __async(this, null, function* () {
      const address = `1.0/features/${featureId}/progressions/${progressionId}/stages/${stageId}/clone`;
      const result = yield this._post(postData, address);
      return result.getSuccessData();
    });
  }
  migrateProgressionToConfigProvider(featureId, progressionId) {
    return __async(this, null, function* () {
      const address = `1.0/features/${featureId}/MigrateProgressionToConfigProvider`;
      const result = yield this._post(progressionId, address);
      return result;
    });
  }
  bulkEditStages(featureId, progressionId, postData) {
    return __async(this, null, function* () {
      const address = `1.0/features/${featureId}/progressions/${progressionId}`;
      const result = yield this._post(postData, address);
      return result;
    });
  }
  updateProgression(featureId, progressionId, postData) {
    return __async(this, null, function* () {
      const address = `1.0/features/${featureId}/progressions/${progressionId}`;
      const result = yield this._patch(postData, address);
      return result;
    });
  }
};
__decorateClass([
  onError({ message: `An error occurred while creating the feature. ${continuationErrorMessage}` })
], FeatureResources.prototype, "createRootFeature", 1);
__decorateClass([
  onError({ message: `An error occurred while updating the root feature. ${continuationErrorMessage}` })
], FeatureResources.prototype, "updateRootFeature", 1);
__decorateClass([
  onError({ message: `An error occurred while initializing the feature. ${continuationErrorMessage}` })
], FeatureResources.prototype, "initializeRootFeature", 1);
__decorateClass([
  onError({ message: `An error occurred while loading the root feature. ${continuationErrorMessage}` })
], FeatureResources.prototype, "loadRootFeature", 1);
__decorateClass([
  onError({ message: `An error occurred while getting a flight. ${continuationErrorMessage}` })
], FeatureResources.prototype, "tryGetFlightRestResult", 1);
__decorateClass([
  onError({ message: `An error occurred while deleting a flight. ${continuationErrorMessage}` })
], FeatureResources.prototype, "tryDeleteFlight", 1);
__decorateClass([
  onError({ message: `An error occurred while getting a flight. ${continuationErrorMessage}` })
], FeatureResources.prototype, "getFlight", 1);
__decorateClass([
  onError({ message: `An error occurred while creating the progression. ${continuationErrorMessage}` })
], FeatureResources.prototype, "createProgression", 1);
__decorateClass([
  onError({ message: `An error occurred while creating the progression stage. ${continuationErrorMessage}` })
], FeatureResources.prototype, "createProgressionStage", 1);
__decorateClass([
  onError({ message: `An error occurred while cloning the progression. ${continuationErrorMessage}` })
], FeatureResources.prototype, "cloneProgression", 1);
__decorateClass([
  onError({ message: `An error occurred while deleting the feature. ${continuationErrorMessage}` })
], FeatureResources.prototype, "hideFeature", 1);
__decorateClass([
  onError({ message: `An error occurred while archiving the progression. ${continuationErrorMessage}` })
], FeatureResources.prototype, "archiveProgression", 1);
__decorateClass([
  onError({ message: `An error occurred while updating the progression's target order. ${continuationErrorMessage}` })
], FeatureResources.prototype, "setTargetOrder", 1);
__decorateClass([
  onError({ message: `An error occurred while updating the progression stage. ${continuationErrorMessage}` })
], FeatureResources.prototype, "updateProgressionsStage", 1);
__decorateClass([
  onError({ message: `An error occurred while deleting the progression stage. ${continuationErrorMessage}` })
], FeatureResources.prototype, "deleteProgressionsStage", 1);
__decorateClass([
  onError({ message: `An error occurred while cloning the progression stage. ${continuationErrorMessage}` })
], FeatureResources.prototype, "cloneProgressionStage", 1);
__decorateClass([
  onError({ message: `An error occurred while migrating the progression. ${continuationErrorMessage}` })
], FeatureResources.prototype, "migrateProgressionToConfigProvider", 1);
__decorateClass([
  onError({ message: `An error occurred while bulk editing progression stages. ${continuationErrorMessage}` })
], FeatureResources.prototype, "bulkEditStages", 1);
__decorateClass([
  onError({ message: `An error occurred while editing progression. ${continuationErrorMessage}` })
], FeatureResources.prototype, "updateProgression", 1);
FeatureResources = __decorateClass([
  WPSProxyConverter(),
  expAdapterService()
], FeatureResources);
const FeatureResources$1 = new FeatureResources();
export {
  FeatureResources,
  FeatureResources$1 as default
};
//# sourceMappingURL=FeatureResources.js.map
